import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    importerCode: "",
    createdByBrokerId: "",
    importerOfRecordNumber: "",
    comment: "",
    reconciliationTypeCode: "",
    importerOfRecordType: "",
}


const createShipmentSlice = createSlice({
    name: "createReconShipment",
    initialState: initialState,
    reducers: {
        updateFieldValue: (state, {payload: {name, value} = {}}) => {
            state[name] = value;
        },
        reInitState: (state, payload) => {
            state = initialState
        }
    }
})

export const { updateFieldValue, reInitState } = createShipmentSlice.actions

export default createShipmentSlice.reducer